import { render, staticRenderFns } from "./AddUserAdmin.vue?vue&type=template&id=17b2bcbe&"
import script from "./AddUserAdmin.vue?vue&type=script&lang=js&"
export * from "./AddUserAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports